import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
// import { ChatEngine } from 'react-chat-engine';
import Navbar from '../Navbar/Navbar';
import EngineChat from '../ChatEngine/EngineChat';


const urls = {
    getUserUrl: "https://api.chatengine.io/users/me/",
    createUserUrl: "https://api.chatengine.io/users/",
    avatar: "https://images.unsplash.com/photo-1511367461989-f85a21fda167?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=889&q=80"
}

const Chats = () => {
    const { user }: any = useSelector(state => state);
    const [loading, setLoading] = useState(true);
    const history = useHistory();

    const getFile = async (url: string) => {
        if (!url) {
            url = urls.avatar
        }
        try {
            const data = await (await fetch(url)).blob();
            return new File([data], "userPhoto.jpg", { type: "image/jpeg" });
        } catch (error) {
            return new File([], "userPhoto.jpg", { type: "image/jpeg" });
        }
    }

    useEffect(() => {

        if (!user) {
            history.push('/');
            return;
        }

        axios.get(urls.getUserUrl, {
            headers: {
                "project-id": process.env.REACT_APP_CHAT_ENGINE_ID,
                'user-name': user.email,
                'user-secret': user.uid
            }
        }).then(() => {
            setLoading(false);
        }).catch(() => {
            // console.log("From Chats/Chats Yes User Doesn't exist");
            
            let data = new FormData();

            data.append('email', user.email);
            data.append('username', user.email);
            data.append('secret', user.uid);

            getFile(user.photoURL)
                .then(picture => {
                    data.append('avatar', picture, picture.name);

                    axios.post(urls.createUserUrl,
                        data,
                        {
                            headers: {
                                "private-key": process.env.REACT_APP_CHAT_ENGINE_KEY
                            }
                        }
                    )
                }).then(() => {
                    // console.log("From getFile in then");
                    setTimeout(() => {
                        setLoading(false);
                    }, 10000);
                    // history.push('/');
                }).catch(error => {
                    // console.log(error);
                });
        })

    }, [user, history]);

    if (!user || loading) {
        return <h5>Loading...</h5>
    }

    return (
        <div>
            <Navbar />
            <EngineChat email={user.email} uid={user.uid}/>
        </div>
    )
}

export default Chats
